let experiencess = [
  {
    tags: ["Expertise"],
    works: [
      {
        name: "Creating responsive, accessible web applications using React.js, Next.js, TypeScript, and modern styling frameworks.",
        type: "workExperience",
      },
    ],
    year: "Front-end Development",
  },
  {
    tags: ["Expertise"],
    works: [
      {
        name: "Architecting REST APIs, WebSocket real-time systems, Spring Boot backends, and SQL/NoSQL database integrations (PostgreSQL, Supabase, MongoDB).",
        type: "workExperience",
      },
    ],
    year: "Back-end Development",
  },
  {
    tags: ["Expertise"],
    works: [
      {
        name: "Building machine learning models (PyTorch CNNs), custom security detection (YARA rules), and systems programs (C, Flex, Bison compilers).",
        type: "workExperience",
      },
    ],
    year: "Software & Systems",
  },
  {
    tags: ["Education"],
    works: [
      {
        company: "York University",
        name: "2022-present",
        type: "workExperience",
      },
    ],
    year: "Specialized Honours B.Sc. in Computer Science",
    courses: [
      { code: "EECS 3101", name: "Data Structures & Algorithms" },
      { code: "EECS 3311", name: "Software Design" },
      { code: "EECS 3404", name: "Applied Machine Learning" },
      { code: "EECS 4482", name: "Computer Security" },
      { code: "EECS 4415", name: "Big Data Systems" },
      { code: "EECS 4412", name: "Data Mining" },
      { code: "EECS 4443", name: "User Interface & Mobile Dev" },
      { code: "EECS 3421", name: "Database Systems" },
    ],
  },
  {
    tags: ["Work"],
    works: [
      {
        desc: "Developed a real-time virtual queue system for efficient handling of student service requests. Built responsive frontend with React.js & Vite, applied SDLC principles, and implemented auth, session management, and WebSockets.",
        name: "Front-End Developer @ Dept. of Computer Science, York University",
        type: "workExperience",
      },
    ],
    year: "Sep 2025 – Present",
  },
  {
    tags: ["Work"],
    works: [
      {
        desc: "Engineered a full-stack banquet RSVP platform with Next.js, React, TypeScript, Framer Motion, Supabase database architecture, Clerk authentication, Stripe payment processing, Resend emails, and QR code check-in admin portal.",
        name: "Full-Stack Developer @ TMA Student Club, York University",
        type: "workExperience",
      },
    ],
    year: "Jan 2026 – Mar 2026",
  },
  {
    tags: ["Work"],
    works: [
      {
        desc: "Updated and managed social media accounts and WordPress sites for the department of humanities.",
        name: "Social Media and Website Assistant @ York University",
        type: "workExperience",
      },
    ],
    year: "2023 – Present",
  },
];

export default experiencess;
